import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="highlight"
// Used in: navbar search
// Purpose: when search results are returned from searches controller, highlight the first result
// Explanation: Works together with search and dropdown controller
export default class extends Controller {
  static targets = ['select'];

  connect() {
    console.log('highlight modal controller connected');
    this.selectTargets.forEach((element, index) => {
      if (index === 0) {
        element.classList.add('selected-search-result');
      } else {
        element.classList.remove('selected-search-result');
      }
    });
  }
}
